import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { Claim } from "@edufadder/shared-types";
import { useAuth } from "../lib/auth-context.js";
import * as api from "../lib/api.js";
import * as s from "../styles.js";

export function ClaimsListPage(): JSX.Element {
  const { hasPermission } = useAuth();
  const [claims, setClaims] = useState<Claim[] | null>(null);
  const [filter, setFilter] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .listClaims()
      .then(setClaims)
      .catch(() => setError("Couldn't load claims."));
  }, []);

  const filtered = (claims ?? []).filter((c) => {
    const haystack = `${c.label} ${c.topic} ${c.aliases.join(" ")}`.toLowerCase();
    return haystack.includes(filter.toLowerCase());
  });

  return (
    <div style={s.container}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 style={s.heading1}>Claims</h1>
        {hasPermission("claims:write") && (
          <Link to="/claims/new" style={{ ...s.buttonPrimary, textDecoration: "none", display: "inline-block" }}>
            New claim
          </Link>
        )}
      </div>
      <input
        style={{ ...s.input, maxWidth: 360 }}
        placeholder="Search by label, topic, or alias…"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />
      {error && <p style={s.errorText}>{error}</p>}
      {claims === null && !error && <p style={s.mutedText}>Loading…</p>}
      {claims !== null && filtered.length === 0 && <p style={s.mutedText}>No claims match that search.</p>}
      {filtered.map((c) => (
        <Link key={c.id} to={`/claims/${c.id}`} style={{ textDecoration: "none", color: "inherit" }}>
          <div style={s.card}>
            <h2 style={s.heading2}>{c.label}</h2>
            <p style={s.mutedText}>Topic: {c.topic}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}
